import { ROLES } from '@/constants/roles';

export const clubsList = {
  path: '/clubs',
  name: 'ui-clubs',
  component: () => import('./views/clubs.vue'),
  meta: {
    layout: 'ui-design',
    title: 'Клубы',
    accessList: [ROLES.trainer, ROLES.certificate, ROLES.member],
  },
};

export const myTeams = {
  path: '/my-teams',
  name: 'ui-my-teams',
  component: () => import('./views/my-teams.vue'),
  meta: {
    layout: 'ui-design',
    title: 'Мои команды',
    accessList: [ROLES.trainer],
  },
};

export const trainerEvents = {
  path: '/results-event',
  name: 'ui-results-event',
  component: () => import('./views/events.vue'),
  meta: {
    layout: 'ui-design',
    title: 'Участия в мероприятиях членов моих команд',
    buttonTitle: 'Результаты участия',
    accessList: [ROLES.trainer],
  },
};

export const trainerAssociations = {
  path: '/trainer-associations',
  name: 'ui-trainer-associations',
  component: () => import('./views/association/list.vue'),
  meta: {
    layout: 'ui-design',
    title: 'Отделения ассоциаций (объединений)',
    buttonTitle: 'Ассоциации',
    accessList: [ROLES.trainer],
  },
};

export default [
  clubsList,
  myTeams,
  trainerEvents,
  trainerAssociations,
  {
    path: '/trainer-association/:id',
    name: 'ui-trainer-association',
    component: () => import('./views/association/index.vue'),
    meta: {
      layout: 'ui-design',
      isDynamicTitle: true,
      // back: true,
      accessList: [ROLES.trainer],
    },
    props: (route) => ({
      id: Number(route?.params?.id),
    }),
    redirect: (to) => ({
      name: 'ui-trainer-association-main',
      params: {
        id: to.params.id,
      },
    }),
    beforeEnter: (to, from, next) => {
      if ([to?.params?.id].includes(undefined)) {
        next({ name: 'ui-trainer-associations' });
        return;
      }
      next();
    },
    children: [
      {
        path: 'main',
        name: 'ui-trainer-association-main',
        component: () => import('./views/association/main.vue'),
        meta: {
          title: 'Моё отделение',
          layout: 'ui-design',
          accessList: [ROLES.trainer],
        },
      },
      {
        path: 'clubs',
        name: 'ui-trainer-association-clubs',
        component: () => import('./views/association/clubs.vue'),
        meta: {
          title: 'Клубы отделения',
          layout: 'ui-design',
          accessList: [ROLES.trainer],
        },
      },
      {
        path: 'members',
        name: 'ui-trainer-association-members',
        component: () => import('./views/association/members.vue'),
        meta: {
          title: 'Члены отделения',
          layout: 'ui-design',
          accessList: [ROLES.trainer],
        },
      },
    ],
  },
  {
    path: '/club/:id',
    name: 'ui-club',
    component: () => import('./views/club/index.vue'),
    meta: {
      layout: 'ui-design',
      title: 'Клуб',
      isDynamicBreadcrumbs: true,
      accessList: [ROLES.trainer],
    },
    props: (route) => ({
      id: route?.params?.id,
    }),
    redirect: (to) => ({
      name: 'ui-club-main',
      params: {
        id: to.params.id,
      },
    }),
    children: [
      {
        path: '/',
        name: 'ui-club-main',
        component: () => import('./views/club/main.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Клуб',
          isDynamicBreadcrumbs: true,
          accessList: [ROLES.trainer],
        },
      },
      {
        path: 'supervisors',
        name: 'ui-club-supervisors',
        component: () => import('./views/club/supervisors.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Ответственные лица',
          isDynamicBreadcrumbs: true,
          accessList: [ROLES.trainer],
        },
      },
      {
        path: 'teams',
        name: 'ui-club-teams',
        component: () => import('./views/club/teams.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Команды клуба',
          isDynamicBreadcrumbs: true,
          accessList: [ROLES.trainer],
        },
      },
      {
        path: 'members',
        name: 'ui-club-members',
        component: () => import('./views/club/members.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Члены клуба',
          isDynamicBreadcrumbs: true,
          accessList: [ROLES.trainer],
        },
      },
      {
        path: 'events',
        name: 'ui-club-events',
        component: () => import('./views/club/events.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Мероприятия клуба',
          isDynamicBreadcrumbs: true,
          accessList: [ROLES.trainer],
        },
      },
      {
        path: 'associations',
        name: 'ui-club-associations',
        component: () => import('./views/club/associations.vue'),
        meta: {
          layout: 'ui-design',
          title: 'Ассоциации и объединения клуба',
          isDynamicBreadcrumbs: true,
          accessList: [ROLES.trainer],
        },
      },
    ],
  },
];
